module.exports = __webpack_public_path__ + "img/logo-graphic.98675df3.svg";